import { makeStyles } from "tss-react/mui";
import { keyframes } from "tss-react";

function getAvatarDimensions(size: "small" | "medium" | "large") {
  switch (size) {
    case "small":
      return 32;
    case "medium":
      return 46;
    case "large":
      return 64;
  }
}

export const useStyles = makeStyles<{
  backgroundColor: string;
  size: "small" | "medium" | "large";
}>()((theme, { backgroundColor, size }) => ({
  badge: {
    "& .MuiBadge-badge": {
      backgroundColor: "#44b700",
      color: "#44b700",
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        animation: `${keyframes`
            0% {
                transform: scale(0.8);
                opacity: 1;
            }
            100% {
                transform: scale(2.4);
                opacity: 0;
            }
            `} 1.2s infinite ease-in-out`,
        border: "1px solid currentColor",
      },
    },
  },
  playerCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  avatar: {
    width: getAvatarDimensions(size),
    height: getAvatarDimensions(size),
    backgroundColor,
  },
  playerName: {
    maxWidth: 120,
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));
